import { GetRowsRequest } from '../../../../../../grid/types/common';

export class GridHelper {
  /**
   * We don't want to filter in back-end, since we're working with very few items.
   * We chose to process the data in front-end only
   *
   * @param request
   * @param gridItems
   * @param gridColumnKeys
   * @private
   */
  public static applyFiltersOnGridItems<ColumIndex extends number, ColumnKey extends string, GridItemType>(
    request: GetRowsRequest<ColumIndex, ColumnKey>,
    gridItems: Array<GridItemType>,
    gridColumnKeys: Array<ColumnKey>
  ): {
    rawEvents: Array<GridItemType>;
  } {
    let filteredData = [...gridItems];

    for (const [index, key] of gridColumnKeys.entries()) {
      const filterValueStartsWith = request.filters[index][key as ColumnKey]['startsWith'];
      const filterValueRegex = request.filters[index][key as ColumnKey]['regex'];

      let regexPattern;

      if (filterValueStartsWith) {
        regexPattern = new RegExp(`^${filterValueStartsWith}`, 'i');
      } else if (filterValueRegex) {
        const filterValue = filterValueRegex.pattern;

        if (filterValue.charAt(0) === '*') {
          regexPattern = new RegExp(filterValue.slice(1), 'i');
        }

        if (filterValue.charAt(filterValue.length - 1) === '*') {
          regexPattern = new RegExp(`^${filterValue.slice(0, -1)}`);
        }
      }

      if (regexPattern) {
        filteredData = filteredData.filter((item: GridItemType) =>
          regexPattern.test(item[key as unknown as keyof GridItemType] as string)
        );
      }
    }

    if (!request.sortDirection) {
      return { rawEvents: filteredData };
    }

    if (request.sortDirection === 'ASC') {
      filteredData.sort((item1, item2) => item1[request.sortColumnName!].localeCompare(item2[request.sortColumnName!]));
    } else {
      filteredData.sort((item1, item2) => item2[request.sortColumnName!].localeCompare(item1[request.sortColumnName!]));
    }

    return { rawEvents: filteredData };
  }
}
